// extracted by mini-css-extract-plugin
export default {"CardBgDark":"SkillCard_CardBgDark__dWXgr","CardBgLight":"SkillCard_CardBgLight__mBWzU"};